function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/Upload/M/Default"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.71,7.29 C12.6178496,7.20004903 12.509193,7.12874313 12.39,7.08 C12.2666759,7.02746347 12.134048,7.00025773 12,7 L11.9,7 C11.8072519,7.00456772 11.7159534,7.02485626 11.63,7.06 C11.5614159,7.08673839 11.4973378,7.12383623 11.44,7.17 C11.3943592,7.19652181 11.35089,7.22661585 11.31,7.26 L8.31,10.12 C7.90959356,10.5010765 7.89392352,11.1345936 8.275,11.535 C8.65607648,11.9354064 9.28959356,11.9510765 9.69,11.57 L11,10.34 L11,16 C11,16.5522847 11.4477153,17 12,17 C12.5522847,17 13,16.5522847 13,16 L13,10.41 L14.29,11.71 C14.4777666,11.8993127 14.7333625,12.0057983 15,12.0057983 C15.2666375,12.0057983 15.5222334,11.8993127 15.71,11.71 C15.8993127,11.5222334 16.0057983,11.2666375 16.0057983,11 C16.0057983,10.7333625 15.8993127,10.4777666 15.71,10.29 L12.71,7.29 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 C16.418278,4 20,7.581722 20,12 C20,14.1217319 19.1571453,16.1565632 17.6568542,17.6568542 C16.1565632,19.1571453 14.1217319,20 12,20 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}));

function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon_upload.739c6743.svg";
export { ForwardRef as ReactComponent };